<template>
  <v-form ref="userForm" v-model="valid">
    <v-layout style="width: 100%" row wrap pb-2>
      <v-flex xs12 pl-2>
        <v-layout class="field-padding" row wrap>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('name')"
              :rules="userRules.name"
              prepend-inner-icon="person"
              v-model="user.name"
              label="Full Name"
              @input="resetError('name')"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('contact_number')"
              :rules="userRules.contact_number"
              prepend-inner-icon="smartphone"
              v-model="user.contact_number"
              label="Mobile Number"
              @input="resetError('contact_number')"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('email')"
              :rules="userRules.email"
              prepend-inner-icon="email"
              v-model="user.email"
              label="Email"
              @input="resetError('email')"
              :disabled="disabled"
              browser-autocomplete="new-email"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('password')"
              :rules="userRules.password"
              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
              prepend-inner-icon="lock"
              :type="showPassword ? 'text' : 'password'"
              v-model="user.password"
              label="Password"
              @input="resetError('password')"
              :disabled="disabled"
              @click:append="showPassword = !showPassword"
              browser-autocomplete="new-password"
            />
          </v-flex>
          <v-flex xs6 md4 px-2>
            <v-text-field
              :error-messages="errorForField('accounting_reference_number')"
              v-model="user.accounting_reference_number"
              label="Accounting Reference Number"
              @input="resetError('accounting_reference_number')"
              :disabled="disabled"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-row pl-2 class="field-padding" wrap>
        <v-row pt-1 wrap align-center justify="start" fill-height>
          <v-flex xs4 md4 px-2>
            <v-text-field
              :error-messages="errorForField('position')"
              :rules="userRules.position"
              prepend-inner-icon="person_outline"
              v-model="user.position"
              label="Position"
              @input="resetError('position')"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs6 md3 px-2>
            <v-checkbox
              v-model="user.locked_out"
              color="primary"
              label="Locked Out"
              :disabled="disabled"
            />
          </v-flex>
          <v-flex xs6 md3 px-2>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-checkbox
                  v-on="on"
                  v-model="user.third_party"
                  color="primary"
                  label="Third Party"
                  :disabled="disabled"
                />
              </template>
              <span>Allows customer to use third party booking devices such as Hotel Tablets</span>
            </v-tooltip>
          </v-flex>
          <v-flex xs12 md6 px-2>
            <v-textarea
              :error-messages="errorForField('notes')"
              :rules="userRules.notes"
              v-model="user.notes"
              label="Notes"
              @input="resetError('notes')"
              :disabled="disabled"
              :rows="3"
            />
          </v-flex>
        </v-row>
      </v-row>
    </v-layout>
  </v-form>
</template>

<script>
export default {
  name: "user_form",
  components: {},
  props: {
    user: Object,
    disabled: Boolean,
    editingUser: false,
    errors: { type: Object, default: () => {} },
  },
  data: function () {
    return {
      valid: false,
      showPassword: false,
      userRules: {
        name: [
          (v) => !!v || "Name is required",
          (v) => (v && v.length <= 100) || "Name cannot exceed 100 characters",
        ],
        email: [(v) => !v || /^.+@.+/.test(v) || "Email must be valid"],
        contact_number: [
          (v) => !!v || "Mobile number is required",
          (v) => /^\+?[0-9]{6,15}$/.test(v) || "Phone number must be valid",
        ],
        password: [],
        discount_percentage: [
          (v) => !!v || "Discount percentage is required",
          (v) =>
            (v && parseInt(v) >= 0 && parseInt(v) <= 100) ||
            "Discount percentage must be between 0 and 100",
        ],
      },
    };
  },
  methods: {
    errorForField: function (field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    resetError: function (field) {
      try {
        if (this.errors[field] != "") {
          this.errors[field] = "";
        }
      } catch (err) {}
    },
    validateForm: function () {
      this.$refs.userForm.validate();
    },
  },
  watch: {
    disabled: function () {
      this.$refs.userForm.reset();
    },
    valid: function () {
      this.$emit("validityChange", this.valid);
    },
  },
};
</script>
